import { render, staticRenderFns } from "./CreateTeams.vue?vue&type=template&id=5c491b7e&scoped=true&"
import script from "./CreateTeams.vue?vue&type=script&lang=ts&"
export * from "./CreateTeams.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTeams.vue?vue&type=style&index=0&id=5c491b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c491b7e",
  null
  
)

export default component.exports